import { Input } from "@heroui/react"
import { useState } from "react"
import { isEmailValid } from "../validate"
import { useMediaQuery } from '@custom-react-hooks/use-media-query';

export const NameInput = ({ name, setName }) => {
    const isDesktop = useMediaQuery(process.env.REACT_APP_IS_DESKTOP);
    const [errorMessage, setErrorMessage] = useState("")

    const handleOnValueChange = (value) => {
        setName(value); // keep exactly what user types

        if (value.trim().length === 0) {
            setErrorMessage("名前を入力してください。");
        } else if(value.length >= 50) {
            setErrorMessage("名前が長すぎます。") // new name is too long
        } else {
            setErrorMessage("");
        }
    };


    return (
        <Input
            size={isDesktop ? "md" : "lg"}
            errorMessage={errorMessage}
            isInvalid={errorMessage !== ""}
            value={name}
            onValueChange={handleOnValueChange}
            label="名"
            type="text"
            classNames={{
                input: `${"group-data-[has-value=true]:text-base-text"}`,
                inputWrapper: ["!rounded-2xl bg-base-input/40 backdrop-blur data-[hover=true]:bg-base-input/80 group-data-[focus=true]:bg-base-input/80 shadow-none", 
                    'rounded-xl', `border border-white/0 ${errorMessage !== "" && "border-red-500"}`],
                label: `text-base-text/60 font-light`,
                errorMessage: "!text-[#98383A]"
            }}
        />
    )
}